"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortData = void 0;
var lodash_1 = require("lodash");
var _EXPORTS_1 = require("./_EXPORTS");
/**
 *
 * @description available fn names:
 * - numerical
 * - alphabetical
 * - date
 * - boolean
 *
 *
 */
var sortData = function (_a) {
    var data = _a.data, _aPath = _a.aPath, _bPath = _a.bPath, path = _a.path, // either u define aPath & bPath separately, or a single path which will be used for both a & b
    _b = _a.fn, // either u define aPath & bPath separately, or a single path which will be used for both a & b
    fn = _b === void 0 ? 'date' : _b, _c = _a.sortBy, sortBy = _c === void 0 ? 'a' : _c;
    var sortedData = (0, lodash_1.cloneDeep)(data);
    sortedData.sort(function (a, b) {
        var sortFnToUse = presetFns[fn];
        var aPath = _aPath !== undefined ? _aPath : path;
        var bPath = _bPath !== undefined ? _bPath : path;
        return sortFnToUse(a, b, aPath, bPath, sortBy);
    }); //a-b === ascending ; b-a === descending ; ref MDN
    return sortedData;
};
exports.sortData = sortData;
var presetFns = {
    numerical: function (a, b, aPath, bPath, sortBy) {
        var aNum = (0, _EXPORTS_1.getVal)(a, aPath);
        var bNum = (0, _EXPORTS_1.getVal)(b, bPath);
        return sortBy === 'a' ? aNum - bNum : bNum - aNum;
    },
    alphabetical: function (a, b, aPath, bPath, sortBy) {
        var aTitle = (0, _EXPORTS_1.getVal)(a, aPath) || 'zzzzzz'; //meaning, if undefined val, then send all the way to the end
        var bTitle = (0, _EXPORTS_1.getVal)(b, bPath) || 'zzzzzz'; //meaning, if undefined val, then send all the way to the end   
        return sortBy
            ? sortBy === 'a'
                ? aTitle.localeCompare(bTitle)
                : bTitle.localeCompare(aTitle)
            : aTitle.localeCompare(bTitle);
    },
    date: function (a, b, aPath, bPath, sortBy) {
        var aDate = (0, _EXPORTS_1.getVal)(a, aPath);
        var bDate = (0, _EXPORTS_1.getVal)(b, bPath);
        return sortBy
            ? sortBy === 'a'
                ? (0, _EXPORTS_1.getDaysDiff)(bDate, aDate).count
                : (0, _EXPORTS_1.getDaysDiff)(aDate, bDate).count
            : (0, _EXPORTS_1.getDaysDiff)(aDate, bDate).count;
    },
    boolean: function (a, b, aPath, bPath, sortBy) {
        var aBool = (0, _EXPORTS_1.getVal)(a, aPath);
        var bBool = (0, _EXPORTS_1.getVal)(b, bPath);
        return sortBy
            ? sortBy === 'a'
                ? (aBool === bBool) ? 0 : aBool ? -1 : 1
                : (bBool === aBool) ? 0 : bBool ? -1 : 1
            : (aBool === bBool) ? 0 : aBool ? -1 : 1;
    },
};
